/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_donut_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentages are calculated automatically.`)
};

const es_donut_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los porcentajes se calculan automáticamente.`)
};

const de_donut_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozentsätze werden automatisch berechnet.`)
};

const nl_donut_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentages worden automatisch berekend.`)
};

const fr_donut_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les pourcentages sont calculés automatiquement.`)
};

const it_donut_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le percentuali vengono calcolate automaticamente.`)
};

const pt_br2_donut_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os percentuais são calculados automaticamente.`)
};

const pt_donut_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As percentagens são calculadas automaticamente.`)
};

const ja_donut_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセンテージは自動的に計算されます。`)
};

const zh_donut_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比会自动计算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const donut_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.donut_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("donut_ex3", locale)
	if (locale === "en") return en_donut_ex3(inputs)
	if (locale === "es") return es_donut_ex3(inputs)
	if (locale === "de") return de_donut_ex3(inputs)
	if (locale === "nl") return nl_donut_ex3(inputs)
	if (locale === "fr") return fr_donut_ex3(inputs)
	if (locale === "it") return it_donut_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_donut_ex3(inputs)
	if (locale === "pt") return pt_donut_ex3(inputs)
	if (locale === "ja") return ja_donut_ex3(inputs)
	return zh_donut_ex3(inputs)
};